// ABOUTME: Context telling the 5B question whether it mounts as an arrival from 4B into an already settled cloud stack.
// ABOUTME: The cloud stack provides it; QuestionBlob reads it once at mount to decide whether its two lines fade in.

import { createContext } from 'react';

// True when the cloud stack is settled, so a question mounting now is an arrival; false on a first paint.
export const QuestionArrivalContext = createContext(false);
